import React from 'react';
import * as ReactRedux from 'react-redux';


const LoadingAnimation = (props) =>{
  return <div className='_LoadingAnimation'>
    <div className='loadingio-spinner-spinner-wa00a2pe3kq' onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}>
      <div className='ldio-lrrtfmtm5tg'>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
        <div/>
      </div>
    </div>
  </div>;
}


export default ReactRedux.connect((state) => ({meta: state.meta, mobile: state.mobile.isMobile}))(LoadingAnimation);
